<template>
  <div>
    <p>Your content profile is indicated below. Use this form to switch to a different profile.</p>
    <div class="form-group">
      <select class="form-control" v-model="selectedProfileId">
        <option
          v-for="profile of profileChoices"
          :value="profile.id"
          :key="profile.id">{{ profile.name }}</option>
      </select>
    </div>

    <div class="btn-toolbar">
      <button
        class="btn btn-primary btn-confirm"
        :disabled="!isConfirmEnabled"
        @click="confirmSelection">Confirm</button>
      <button class="btn btn-default btn-cancel" @click="cancelSelection">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentProfileSelector',
  props: {
    profileChoices: {
      type: Array,
      required: true
    },
    currentlyActiveProfileId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedProfileId: ''
    }
  },
  computed: {
    isDirty() {
      return this.currentlyActiveProfileId !== this.selectedProfileId
    },
    isConfirmEnabled() {
      return (this.selectedProfileId && this.isDirty) || false
    }
  },
  methods: {
    confirmSelection() {
      this.$emit('cpselect:confirmed', this.selectedProfileId)
    },
    cancelSelection() {
      this.selectedProfileId = this.currentlyActiveProfileId
      this.$emit('cpselect:canceled')
    }
  },
  created() {
    this.selectedProfileId = this.currentlyActiveProfileId
  }
}
</script>

<style scoped lang="less">
ul {
  margin-bottom: 32px;
}
</style>
